const withinDotOffsetPx = 0.5;

export default {
  dotByDotOffsetCoordArgs(x, y, offsetPx = withinDotOffsetPx) {
    let offsetX = Math.round(x);
    let offsetY = Math.round(y);
    return [ offsetX + offsetPx, offsetY + offsetPx ];
  },

  dotByDotOffsetRectArgs(x, y, width, height, offsetPx = withinDotOffsetPx) {
    let offsetX = Math.round(x);
    let offsetY = Math.round(y);
    let endX = x + width;
    let endY = y + height;
    let offsetEndX = Math.round(endX);
    let offsetEndY = Math.round(endY);
    let offsetWidth = offsetEndX - offsetX;
    let offsetHeight = offsetEndY - offsetY;
    return [ offsetX + offsetPx, offsetY + offsetPx, offsetWidth, offsetHeight ];
  },

  drawLine(
    context,
    { x: beginX, y: beginY },
    { x: endX = undefined, y: endY = undefined },
    {
      lineWidth = 1,
      lineDash = undefined,
      strokeStyle = undefined,
      round = true,
      anchor = 0,
    } = {},
  ) {
    if ((endX === undefined) && (endY === undefined)) throw 'no end point is set';
    if (round) {
      beginX = Math.round(beginX);
      beginY = Math.round(beginY);
      if (endX !== undefined) endX = Math.round(endX);
      if (endY !== undefined) endY = Math.round(endY);
    }
    if (endX === undefined) endX = beginX;
    if (endY === undefined) endY = beginY;
    let offsetX = endX - beginX;
    let offsetY = endY - beginY;
    let lineLength;
    if (offsetX === 0) {
      lineLength = Math.abs(offsetY);
    } else if (offsetY === 0) {
      lineLength = Math.abs(offsetX);
    } else {
      lineLength = Math.sqrt(offsetX ** 2 + offsetY ** 2);
    }
    let offsetRate = 0.5 * lineWidth / lineLength;
    let anchorOffset = 1 - 2 * anchor;
    let pathCenteringOffsetX = offsetRate * (-anchorOffset * offsetY);
    let pathCenteringOffsetY = offsetRate * (anchorOffset * offsetX);
    beginX += pathCenteringOffsetX;
    beginY += pathCenteringOffsetY;
    endX += pathCenteringOffsetX;
    endY += pathCenteringOffsetY;
    context.beginPath();
    context.moveTo(beginX, beginY);
    context.lineTo(endX, endY);
    context.lineWidth = lineWidth;
    if (lineDash !== undefined) context.setLineDash(lineDash);
    if (strokeStyle !== undefined) context.strokeStyle = strokeStyle;
    context.stroke();
  },

  drawRect(
    context, { x: beginX = 0, y: beginY = 0, width, height },
    {
      lineWidth = 1,
      lineDash = undefined,
      stroke = false,
      strokeStyle = undefined,
      fill = false,
      fillStyle = undefined,
      round = true,
      anchor = 0,
    } = {},
  ) {
    if (round) {
      let endX = beginX + width;
      let endY = beginY + height;
      beginX = Math.round(beginX);
      beginY = Math.round(beginY);
      width = Math.round(endX) - beginX;
      height = Math.round(endY) - beginY;
    }
    let anchorOffset = 2 * anchor - 1;
    let sizeOffset = lineWidth * anchorOffset;
    let centeringOffset = -lineWidth * anchorOffset / 2;
    context.beginPath();
    context.lineWidth = lineWidth;
    context.rect(beginX + centeringOffset, beginY + centeringOffset, width + sizeOffset, height + sizeOffset);
    if (lineDash !== undefined) context.setLineDash(lineDash);
    if (stroke) {
      if (strokeStyle !== undefined) context.strokeStyle = strokeStyle;
      context.stroke();
    }
    if (fill) {
      if (fillStyle !== undefined) context.fillStyle = fillStyle;
      context.fill();
    }
  },
}
